export default "__VITE_ASSET__DvgxG5iw__";